export const PostData = [
    {
        id: 1,
        subject: 'Developing',
        date: 'June 15,2022',
        title: 'On the head with free internet',
        content: 'Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.'
    },
    {
        id: 2,
        subject: 'Businees',
        date: 'June 14,2022',
        title: 'Desing in the craetion of a plan or convention',
        content: 'Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.'
    },
    {
        id: 3,
        subject: 'Developing',
        date: 'June 13,2022',
        title: 'On the head with free internet',
        content: 'Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.'
    },
    {
        id: 4,
        subject: 'Developing',
        date: 'June 12,2022',
        title: 'Desing in the craetion of a plan or convention',
        content: 'Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.'
    },
    {
        id: 5,
        subject: 'Businees',
        date: 'June 11,2022',
        title: 'On the head with free internet',
        content: 'Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.'
    },
    {
        id: 6,
        subject: 'Businees',
        date: 'June 10,2022',
        title: 'Desing in the craetion of a plan or convention',
        content: 'Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.'
    },
    {
        id: 7,
        subject: 'Developing',
        date: 'June 9,2022',
        title: 'On the head with free internet',
        content: 'Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.'
    },
    {
        id: 8,
         subject: 'Businees',
        date: 'June 8,2022',
        title: 'Desing in the craetion of a plan or convention',
        content: 'Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.'
    },
    {
        id: 9,
        subject: 'Developing',
        date: 'June 7,2022',
        title: 'On the head with free internet',
        content: 'Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.'
    },
    {
        id: 10,
        subject: 'Developing',
        date: 'June 6,2022',
        title: 'Desing in the craetion of a plan or convention',
        content: 'Lorem Ipsum has been the industrys standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book.It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged.'
    },

]